import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/pickup-card-creations', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const uploadPhoto = data => {
  return httpClient
    .post('/api/pickup-card-creations/upload-photoes', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/pickup-card-creations', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/pickup-card-creations/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/pickup-card-creations/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = data => {
  return httpClient
    .post('/api/pickup-card-creations/delete-records', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getParent = student_id => {
  return httpClient
    .get('/api/pickup-card-creations/parents', {
      params: { student_id: student_id }
    })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const increaseCounter = studentPickupId => {
  return httpClient
    .get(`/api/pickup-card-creations/${studentPickupId}/increase-printer-counters`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const printCard = (Options = {}) => {
  return httpClient
    .get('/api/pickup-card-creations/preview-cards', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  uploadPhoto,
  store,
  find,
  update,
  destroy,
  getParent,
  printCard,
  increaseCounter
}
